import { getAPI, postAPI } from "../../api";
import { REACT_APP_RECRUITER, REACT_APP_CANDIDATEFILTER } from "../../utils/common";


export async function getFilteredCandidates(body: any, value?: string){
    const Details = postAPI(`https://search-ellow-search-domain-fvnpbwyevk23oqh3frpowbqpv4.ap-south-1.es.amazonaws.com/app-resources/_search?${value ? `q=${value}` : ''}`, body)
    return Details
}

export async function getAllocatedto() {
    const Details = getAPI( REACT_APP_RECRUITER + "/list")
    return Details
}

export async function getCandidates(tabName: string,  pageSize: number, pageNumber: number, searchValue: string, body?: any){
    const Details = postAPI( REACT_APP_CANDIDATEFILTER + `/candidate-filter?page=${pageNumber}&size=${pageSize}&tab=${tabName}&search=${searchValue}`, body)
    return Details
}
